import React, { useEffect, useState, useRef } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import QRCode from 'qrcode';
import Page from 'Components/Page';
import config from 'Config/firebase';
import * as actions from 'Store/actions';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import Loading from 'Components/Loading';
import history from '../../history';

const pageStyles = theme => ({
  pageWrapper: {
    padding: '5%',
  },
  pageHeader: {
    marginBottom: '55px',
  },
  itemContainer: {
    marginTop: '40px',
  },
  textArea: {
    fontSize: 20,
  },
  contactButton: {
    marginTop: 70,
  },
  exitButtons: {
    marginTop: '40px',
  },
  submitButton: {
    marginTop: 40,
    marginLeft: 0,
  },
  button: {
    alignSelf: 'flex-start',
    marginTop: '70px',
    marginRight: '20px',
  },
  itemHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '90px',
  },
  itemName: {
    marginBottom: 20,
  },
  itemNameLink: {
    marginBottom: 20,
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
  itemOverview: {
    marginBottom: 70,
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  itemMainInformation: {
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      marginBottom: '50px',
    },
  },
  itemMessage: {
    marginBottom: 0,
  },
  contactHeader: {
    marginBottom: '15px',
  },
  phoneNumber: {
    fontSize: '14px',
    lineHeight: '14px',
    fontFamily: 'Roboto',
    letterSpacing: '0.5px',
  },
  itemImage: {
    maxHeight: '300px',
    maxWidth: '300px',
    cursor: 'pointer',
  },
  imageAndCodeContainer: {
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  successMessage: {
    marginTop: '50px',
  },
  downloads: {
    width: '500px',
    display: 'flex',
    justifyContent: 'space-around',
  },
});

function CodeDetails({ classes, getItem, item, id }) {
  const [qrCodeDataSmall, setQRCodeDataSmall] = useState('');
  const [qrCodeDataLarge, setQRCodeDataLarge] = useState('');
  const canvasEl = useRef(null);

  useEffect(() => {
    const link = `${config.registrationBase}/${id}`;
    QRCode.toCanvas(canvasEl.current, link, { width: 500, margin: 2 }, function (error) {
      if (error) console.error(error);
      console.log('success!');
    });
    QRCode.toDataURL(link, { width: 500, margin: 2 }, function (err, url) {
      setQRCodeDataSmall(url);
    });
    QRCode.toDataURL(link, { width: 1500, margin: 2 }, function (err, url) {
      setQRCodeDataLarge(url);
    });
  }, [id]);

  if (item.loading) {
    return (
      <Loading
        type={'bubbles'}
        color={'#ccc'}
        height={'80px'}
        width={'80px'}
        containerHeight={'70vh'}
        containerWidth={'100%'}
        message={'Loading item...'}
      />
    );
  }

  return (
    <Page wrapperStyles={classes.pageWrapper}>
      <div key={item.itemId} className={classes.itemContainer}>
        <h2>Registration Form Details</h2>
        <p>
          Form ID: <b>{id}</b>
        </p>
        <p>Download and include this QR code in your print material or use this link</p>
        {/* <p>Number of code scans is:</p> */}
        <p>
          URL: <a href={`${config.registrationBase}/${id}`}>{`${config.registrationBase}/${id}`}</a>
        </p>

        <canvas width="600" height="600" ref={canvasEl} id="canvas"></canvas>
        <p className={classes.downloads}>
          <a href={qrCodeDataSmall} download={`qrcode-${id}-500x500.png`}>
            Download 500 X 500 PNG
          </a>
          <a href={qrCodeDataLarge} download={`qrcode-${id}-1500x1500.png`}>
            Download 1500 X 1500 PNG
          </a>
        </p>

        <p>
          <Button
            to="/product-registration/dashboard"
            type="button"
            variant="contained"
            color="secondary"
            className={classes.button}
            component={Link}
          >
            Go to dashboard
          </Button>

          <Button
            to="/product-registration/customers"
            type="button"
            variant="contained"
            color="secondary"
            className={classes.button}
            component={Link}
          >
            See results
          </Button>
        </p>
      </div>
    </Page>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getItem: actions.getItem,
    },
    dispatch,
  );
}

function mapStateToProps({ item }, ownProps) {
  return {
    id: ownProps.match.params.id,
    item,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(pageStyles)(CodeDetails)));
